import React from 'react';
import { InjectedIntl, injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import FooterContainer from '../../../footer/FooterContainer';
import Header from '../../../header/Header';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { COLORS, MQS, SIZES, SPACINGS } from '../constants/styles';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../reduxRootState.interface';
import { IClientConfig } from '../../../config/clientConfig';
import { TextHelpers } from '../../../utils/textHelpers';
import { InfoIcon } from './icons/InfoIcon';

const Page = styled.div`
    background-image: url("data:image/svg+xml,%3Csvg width='1252' height='875' viewBox='0 0 1252 875' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.2'%3E%3Cpath opacity='0.2' d='M199.898 215.369C267.943 100.086 367.267 79.7743 488.267 83.8916C591.706 87.4598 703.652 115.732 798.586 77.0295C893.52 38.3274 958.273 -31.9404 1060.61 -26.7252C1198.08 -19.5886 1258.44 89.9302 1251.31 196.979C1241.43 345.2 1113.57 419.31 985.71 409.978C880.076 402.018 767.856 391.587 674.294 459.11C588.14 521.418 531.069 658.934 410.344 661.953C273.43 665.521 74.2334 428.917 199.898 215.369Z' fill='url(%23paint0_linear)'/%3E%3Cpath opacity='0.2' d='M-204.132 650.073C-158.311 524.36 -64.1999 486.207 55.428 468.64C157.77 453.543 273.008 460.954 359.437 405.783C445.865 350.612 496.625 269.639 598.418 256.19C734.783 238.074 814.077 335.241 826.699 441.466C843.984 589.138 731.49 685.207 604.18 698.931C498.82 710.459 386.6 720.341 306.756 803.784C233.224 880.639 202.219 1026.39 83.9631 1051.09C-50.2067 1079.36 -289.188 882.835 -204.132 650.073Z' fill='url(%23paint1_linear)'/%3E%3Cpath opacity='0.2' d='M1004.28 763.676C1088.38 763.676 1156.56 695.472 1156.56 611.338C1156.56 527.204 1088.38 459 1004.28 459C920.178 459 852 527.204 852 611.338C852 695.472 920.178 763.676 1004.28 763.676Z' fill='url(%23paint2_linear)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='575.725' y1='56.7507' x2='899.677' y2='608.351' gradientUnits='userSpaceOnUse'%3E%3Cstop/%3E%3Cstop offset='0.23' stop-color='%23050505'/%3E%3Cstop offset='0.49' stop-color='%23131313'/%3E%3Cstop offset='0.77' stop-color='%23292929'/%3E%3Cstop offset='1' stop-color='%23424242'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='159.659' y1='653.385' x2='922.424' y2='655.223' gradientUnits='userSpaceOnUse'%3E%3Cstop/%3E%3Cstop offset='0.23' stop-color='%23050505'/%3E%3Cstop offset='0.49' stop-color='%23131313'/%3E%3Cstop offset='0.77' stop-color='%23292929'/%3E%3Cstop offset='1' stop-color='%23424242'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear' x1='851.886' y1='611.449' x2='1156.44' y2='611.449' gradientUnits='userSpaceOnUse'%3E%3Cstop/%3E%3Cstop offset='0.23' stop-color='%23050505'/%3E%3Cstop offset='0.49' stop-color='%23131313'/%3E%3Cstop offset='0.77' stop-color='%23292929'/%3E%3Cstop offset='1' stop-color='%23424242'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;

    footer {
        background: transparent;
    }
`;

const Container = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: center;

    @media (max-width: ${MQS.mq2Min}) {
        flex-direction: column;
        max-height: 100%;
    }
`;

const LineWrapper = styled.div`
    padding: ${SPACINGS.base * 2}px;
    width: 100%;
    max-width: ${SIZES.appMaxWidth}px;
    margin: 0 auto;
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: ${MQS.mq2Min}) {
        flex-direction: row;
    }
`;

const ErrorImage = styled.div`
    flex: 1 1 30%;
    padding: 0 75px 0 0;
    text-align: center;

    @media (max-width: ${MQS.mq2Min}) {
        & svg {
            height: 186px;
        }
        padding: 36px 0 16px 0;
    }
`;

const VerticalLine = styled.div`
    border-left: 1px solid ${COLORS.rakutenRed};

    @media (max-width: ${MQS.mq2Min}) {
        border-top: 1px solid ${COLORS.rakutenRed};
        border-left: none;
        margin: 0 1.5rem 1rem 1.5rem;
    }
`;

const ErrorContent = styled.div`
    flex: 1 1 70%;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding-top: 1rem;
    @media (max-width: ${MQS.mq2Min}) {
        padding: ${SPACINGS.base * 5}px ${SPACINGS.base * 2}px 0px ${SPACINGS.base * 2}px;
        margin: 0rem;
        flex-direction: column;
    }
`;

const ErrorDescription = styled.div`
    flex: 1 1 auto;
    @media (max-width: ${MQS.mq2Min}) {
        width: 100%;
    }

    @media (min-width: ${MQS.mq2Min}) and (max-width: ${MQS.mq2Max}) {
        width: 43%;
    }
`;

const ErrorDescriptionBody = styled.div`
    color: ${COLORS.rakutenRed};
    font-size: 2.25rem;
    font-weight: 500;
    line-height: 2.19rem;
    text-align: left;
    margin: 0;
    max-width: 650px;

    @media (max-width: ${MQS.mq2Min}) {
        font-size: 1.5rem;
        margin: 0;
    }
`;

const ErrorDescriptionTitle = styled.h1`
    color: ${COLORS.rakutenRed};
    font-size: 2.25rem;
    font-weight: 500;
    line-height: 2.19rem;
    text-align: left;
    margin: 0;
    max-width: 650px;

    @media (max-width: ${MQS.mq2Min}) {
        font-size: 1.5rem;
        margin: 0;
        position: absolute;
        top: 12px;
    }
`;

const Separator = styled.hr`
    display: none;

    @media (max-width: ${MQS.mq2Min}) {
        display: block;
        border: 0;
        border-bottom: solid 1px ${COLORS.rakutenRed};
        margin: 0 1.5rem;
    }
`;

const ErrorCode = styled.strong`
    color: ${COLORS.dark};
    display: block;
    font-size: 1rem;
    margin-top: 2.25rem;
    line-height: 1.6rem;

    @media (max-width: ${MQS.mq2Min}) {
        margin-top: 0rem;
    }
`;

const ErrorCodeDescription = styled.div`
    color: ${COLORS.dark};
    display: block;
    font-size: 1rem;
    line-height: 1.6rem;
    @media (max-width: ${MQS.mq2Min}) {
        margin-bottom: 0rem;
    }
`;

const TextLight = styled.div`
    line-height: 1.5;
    margin-top: 1rem;
    font-weight: 300;
    @media (max-width: ${MQS.mq2Min}) {
        margin-bottom: 0rem;
    }
`;

const StyledLink = styled('a')`
    background: ${COLORS.rakutenRed};
    border-radius: 4px;
    color: ${COLORS.white};
    display: inline-block;
    margin-top: ${SPACINGS.base * 4}px;
    text-align: center;
    padding: 8px 16px;
    text-decoration: none;

    &:hover {
        opacity: 0.7;
    }

    @media (max-width: ${MQS.mq2Min}) {
        margin-top: ${SPACINGS.base}px;
    }
`;

const OptionBlack = styled.div`
    padding: ${SPACINGS.base * 2}px;
    width: 100%;
    max-width: ${SIZES.appMaxWidth}px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: row;

    @media (max-width: ${MQS.mq2Min}) {
        flex-direction: column;
        padding-top: 1rem;
    }
`;

const OptionsTitle = styled.p`
    font-size: 1.25rem;
    @media (max-width: ${MQS.mq2Min}) {
        margin-top: 0rem;
    }
`;

const StrongText = styled.strong`
    font-weight: 700;
`;

const Options = styled.div`
    padding: 0 24px;
`;

const Item = styled.li``;

const List = styled.ul`
    line-height: 22.4px;
    font-size: 0.875rem;
    list-style: ${(props: { decimal: boolean }) => (props.decimal ? 'decimal' : 'disc')};
    padding-left: 20px;
    & > li {
        &::marker {
            color: ${(props: { decimal: boolean }) =>
                props.decimal ? COLORS.dark : COLORS.rakutenRed};
        }
    }
`;

const ButtonArea = styled.div`
    @media (max-width: ${MQS.mq2Min}) {
        text-align: center;
    }
`;

const InfoBlock = styled.div`
    background: ${COLORS.grey4};
    border-radius: 12px;
    max-width: 1080px;
    width: 100%;
    display: flex;
    @media (max-width: ${MQS.mq2Min}) {
        max-width: 100%;
        margin: 1rem 1.5rem;
    }
    > p {
        margin: 0;
        padding: 22px 26px 22px 10px;
    }
`;

const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    padding-top: 22px;
`;

const Link = styled.p`
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    @media (max-width: ${MQS.mq2Min}) {
        text-align: center;
        margin: 1rem;
    }

    a {
        color: ${COLORS.rakutenRed};
    }
`;

interface INoMatchProps {
    appConfig: any;
    clientConfig: IClientConfig;
    contentId: string;
    configPresent: boolean;
    intl: InjectedIntl;
    locale: string;
}
interface BackButtonProps {
    knownPlaceUrl: string;
    returnUrlText: string;
    noClientIdUrl: string;
}

const BackButton = ({ knownPlaceUrl, returnUrlText, noClientIdUrl }: BackButtonProps) => {
    return (
        <ButtonArea>
            <StyledLink href={knownPlaceUrl ?? noClientIdUrl} className="tst-btk">
                {knownPlaceUrl
                    ? TranslationHelpers.getFormattedMessage('button.back_to_site', {
                          site: returnUrlText,
                      })
                    : TranslationHelpers.getFormattedMessage('button.back_to_known')}
            </StyledLink>
        </ButtonArea>
    );
};

const ErrorPage = ({
    contentId,
    intl,
    clientConfig,
    appConfig,
    configPresent,
    locale,
}: INoMatchProps) => {
    const numberOfOptions = Number(
        intl.formatMessage(TranslationHelpers.getMessageDescriptor(`${contentId}.options`)),
    );

    const knownPlaceUrl = clientConfig ? clientConfig.returnUrl : '';
    let knownPlaceUrlText;

    if (knownPlaceUrl) {
        // remove protocol and query from url
        knownPlaceUrlText = knownPlaceUrl.replace(/(^http(s)?:\/\/)|(\?.*$)/g, '');
        knownPlaceUrlText = knownPlaceUrlText.charAt(0).toUpperCase() + knownPlaceUrlText.slice(1);
    }

    const returnUrlText = clientConfig.returnUrlText
        ? TextHelpers.returnUrlTextConfigHandle(clientConfig.returnUrlText, locale)
        : knownPlaceUrl;

    return (
        <Page>
            {configPresent ? <Header /> : ''}
            <Container>
                <LineWrapper>
                    <ErrorContent>
                        <ErrorImage>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="184"
                                height="245"
                                viewBox="0 0 184 245"
                                fill="none"
                            >
                                <path
                                    d="M0.399762 63.8312C0.350476 63.9461 0.334048 64.0664 0.290238 64.1813C0.153333 64.5695 0.0711905 64.9742 0.0438095 65.3789C0.0492857 65.4609 0 65.5375 0 65.625V240.625C0 243.042 1.96048 245 4.38095 245H179.619C182.04 245 184 243.042 184 240.625V4.375C184 1.95781 182.04 0 179.619 0H61.3333C61.2402 0 61.169 0.0492188 61.0814 0.0546875C60.6707 0.0765625 60.271 0.153125 59.8876 0.295313C59.7398 0.344531 59.5919 0.399219 59.4495 0.459375C59.0881 0.634375 58.754 0.858594 58.4583 1.12109C58.3652 1.18672 58.2721 1.26328 58.1845 1.33984C58.1845 1.33984 58.1352 1.36719 58.1188 1.38906L1.16643 62.6391C0.843333 63 0.585952 63.3992 0.399762 63.8312ZM56.9524 15.5203V61.25H14.4243L56.9524 15.5203ZM8.7619 70H61.3333C63.7538 70 65.7143 68.0422 65.7143 65.625V8.75H175.238V236.25H8.7619V70Z"
                                    fill="#979797"
                                />
                                <path
                                    d="M72.9758 112.618C73.288 112.323 73.5618 111.989 73.7699 111.617C73.8794 111.475 73.978 111.333 74.0656 111.18C74.6132 110.042 74.6132 108.713 74.0656 107.576C73.978 107.423 73.8794 107.275 73.7699 107.138C73.5563 106.766 73.288 106.427 72.9758 106.132C72.9156 106.083 72.8992 106.006 72.8335 105.957L50.9287 88.457C49.0394 86.9476 46.2794 87.2538 44.768 89.1405C43.2566 91.0273 43.5632 93.7835 45.4525 95.2929L57.6042 105H43.8097C41.3892 105 39.4287 106.958 39.4287 109.375C39.4287 111.792 41.3892 113.75 43.8097 113.75H57.6042L45.4525 123.457C43.5632 124.966 43.2566 127.723 44.768 129.609C46.2794 131.496 49.0394 131.802 50.9287 130.293L72.8335 112.793C72.8937 112.744 72.9156 112.667 72.9758 112.618Z"
                                    fill="#979797"
                                />
                                <path
                                    d="M140.191 105H126.396L138.548 95.2929C140.437 93.7835 140.744 91.0273 139.232 89.1405C137.721 87.2538 134.961 86.9476 133.072 88.457L111.167 105.957C111.107 106.006 111.085 106.077 111.024 106.132C110.712 106.427 110.438 106.761 110.23 107.133C110.121 107.275 110.022 107.417 109.935 107.57C109.387 108.708 109.387 110.037 109.935 111.174C110.022 111.327 110.121 111.469 110.23 111.612C110.444 111.984 110.712 112.323 111.024 112.612C111.085 112.662 111.101 112.738 111.167 112.787L133.072 130.287C134.961 131.797 137.721 131.491 139.232 129.604C140.744 127.717 140.437 124.961 138.548 123.451L126.396 113.75H140.191C142.611 113.75 144.572 111.792 144.572 109.375C144.572 106.958 142.611 105 140.191 105Z"
                                    fill="#979797"
                                />
                                <path
                                    d="M91.9999 144.375C75.9163 144.326 61.4318 154.082 55.4408 168.984C54.5537 171.221 55.638 173.753 57.8723 174.655C60.1066 175.558 62.6475 174.491 63.562 172.266C68.2442 160.688 79.4977 153.103 91.9999 153.103C104.502 153.103 115.756 160.683 120.438 172.266C121.018 173.726 122.332 174.765 123.893 174.984C125.448 175.208 127.004 174.579 127.973 173.337C128.937 172.096 129.161 170.439 128.564 168.984C122.568 154.082 108.083 144.326 91.9999 144.375Z"
                                    fill="#979797"
                                />
                            </svg>
                        </ErrorImage>
                        <ErrorDescription>
                            <ErrorDescriptionTitle>
                                {TranslationHelpers.getFormattedMessage(`${contentId}.title`)}
                            </ErrorDescriptionTitle>
                            <ErrorDescriptionBody>
                                <ErrorCode>
                                    {TranslationHelpers.getFormattedMessage(`${contentId}.code`)}
                                </ErrorCode>
                                <ErrorCodeDescription>
                                    <TextLight>
                                        {TranslationHelpers.getFormattedMessage(
                                            `${contentId}.text`,
                                        )}
                                    </TextLight>
                                    <TextLight>
                                        {TranslationHelpers.getFormattedMessage(
                                            `${contentId}.text1`,
                                            {
                                                n: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            'button.back_to_site',
                                                            {
                                                                site: returnUrlText,
                                                            },
                                                        )}
                                                    </StrongText>
                                                ),
                                            },
                                        )}
                                    </TextLight>
                                    {contentId === 'p400' ? (
                                        <BackButton
                                            knownPlaceUrl={knownPlaceUrl}
                                            returnUrlText={returnUrlText}
                                            noClientIdUrl={appConfig.NO_CLIENT_ID_URL}
                                        ></BackButton>
                                    ) : null}
                                </ErrorCodeDescription>
                            </ErrorDescriptionBody>
                        </ErrorDescription>
                    </ErrorContent>
                </LineWrapper>
                {contentId === 'p400' ? (
                    <LineWrapper>
                        <InfoBlock>
                            <IconWrapper>
                                <InfoIcon></InfoIcon>
                            </IconWrapper>
                            <p>{TranslationHelpers.getFormattedMessage(`${contentId}.text2`)}</p>
                        </InfoBlock>
                    </LineWrapper>
                ) : null}
                <LineWrapper>
                    <OptionBlack>
                        <Options>
                            <OptionsTitle>
                                {TranslationHelpers.getFormattedMessage(`${contentId}.option`, {
                                    browser: <StrongText>Google Chrome</StrongText>,
                                })}
                            </OptionsTitle>
                            <List decimal={contentId === 'p400'}>
                                {[...Array(numberOfOptions)].map((_, i) => (
                                    <Item key={i}>
                                        {TranslationHelpers.getFormattedMessage(
                                            `${contentId}.option${i + 1}`,
                                            {
                                                a: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            `${contentId}.option.a`,
                                                        )}
                                                    </StrongText>
                                                ),
                                                b: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            `${contentId}.option.b`,
                                                        )}
                                                    </StrongText>
                                                ),
                                                c: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            `${contentId}.option.c`,
                                                        )}
                                                    </StrongText>
                                                ),
                                                d: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            `${contentId}.option.d`,
                                                        )}
                                                    </StrongText>
                                                ),
                                                e: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            `${contentId}.option.e`,
                                                        )}
                                                    </StrongText>
                                                ),
                                                f: (
                                                    <StrongText>
                                                        {TranslationHelpers.getFormattedMessage(
                                                            `${contentId}.option.f`,
                                                        )}
                                                    </StrongText>
                                                ),
                                            },
                                        )}
                                    </Item>
                                ))}
                            </List>
                        </Options>
                        <VerticalLine />
                        <Options>
                            <OptionsTitle>
                                {TranslationHelpers.getFormattedMessage(`${contentId}.operate`, {
                                    browser: <StrongText>Microsoft Edge</StrongText>,
                                    site: returnUrlText,
                                })}
                            </OptionsTitle>
                            {contentId !== 'p400' ? (
                                <BackButton
                                    knownPlaceUrl={knownPlaceUrl}
                                    returnUrlText={returnUrlText}
                                    noClientIdUrl={appConfig.NO_CLIENT_ID_URL}
                                ></BackButton>
                            ) : (
                                <List decimal={contentId === 'p400'}>
                                    {[...Array(3)].map((_, i) => (
                                        <Item key={i}>
                                            {TranslationHelpers.getFormattedMessage(
                                                `${contentId}.operate${i + 1}`,
                                                {
                                                    a: (
                                                        <StrongText>
                                                            {TranslationHelpers.getFormattedMessage(
                                                                `${contentId}.operate.a`,
                                                            )}
                                                        </StrongText>
                                                    ),
                                                    b: (
                                                        <StrongText>
                                                            {TranslationHelpers.getFormattedMessage(
                                                                `${contentId}.operate.b`,
                                                            )}
                                                        </StrongText>
                                                    ),
                                                    c: (
                                                        <StrongText>
                                                            {TranslationHelpers.getFormattedMessage(
                                                                `${contentId}.operate.c`,
                                                            )}
                                                        </StrongText>
                                                    ),
                                                    d: (
                                                        <StrongText>
                                                            {TranslationHelpers.getFormattedMessage(
                                                                `${contentId}.operate.d`,
                                                            )}
                                                        </StrongText>
                                                    ),
                                                    e: (
                                                        <StrongText>
                                                            {TranslationHelpers.getFormattedMessage(
                                                                `${contentId}.operate.e`,
                                                            )}
                                                        </StrongText>
                                                    ),
                                                    f: (
                                                        <StrongText>
                                                            {TranslationHelpers.getFormattedMessage(
                                                                `${contentId}.operate.f`,
                                                            )}
                                                        </StrongText>
                                                    ),
                                                },
                                            )}
                                        </Item>
                                    ))}
                                </List>
                            )}
                        </Options>
                    </OptionBlack>
                </LineWrapper>
                {contentId === 'p400' ? (
                    <LineWrapper>
                        <Link>
                            {TranslationHelpers.getFormattedMessage(`${contentId}.text3`, {
                                link: (
                                    <a href="https://ichiba.faq.rakuten.net/?scid=wi_myr_helplink">
                                        {TranslationHelpers.getFormattedMessage(
                                            `${contentId}.text4`,
                                        )}
                                    </a>
                                ),
                            })}
                        </Link>
                    </LineWrapper>
                ) : null}
            </Container>
            <FooterContainer />
        </Page>
    );
};

const mapStateToProps = (state: IReduxRootState) => {
    return {
        appConfig: state.app.appConfig,
        clientConfig: state.app.clientConfig,
        configPresent: state.app && state.app.isReady,
        locale: state.app.locale,
    };
};

export default connect(mapStateToProps)(injectIntl(ErrorPage));
